<script lang="ts">
  interface Props {
    size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl'
    centered?: boolean
    width?: 'restricted' | 'full'
    spacing?: 'default' | 'none'
    children?: import('svelte').Snippet
  }

  let {
    size = 'md',
    centered = false,
    width = 'restricted',
    spacing = 'default',
    children,
  }: Props = $props()
</script>

<div
  class="paragraph size-{size} width-{width} spacing-{spacing}"
  class:centered
>
  {@render children?.()}
</div>

<style lang="postcss">
  .paragraph {
    --_font: 'not set';
    --_pt: 'not set';
    --_pb: 'not set';

    padding-block: var(--_pt) var(--_pb);
    font: var(--_font);

    &.width-restricted {
      max-width: 30em;
    }

    & > :global(p:not(:first-child)) {
      margin-top: 1em;
    }

    &.size-sm {
      --_font: var(--text-sm);
      --_pb: 1.5rem;
    }
    &.size-md {
      --_font: var(--text-md);
      --_pb: 1.5rem;
    }
    &.size-lg {
      --_font: var(--text-lg);
      --_pb: 2.75rem;
    }
    &.size-xl {
      --_font: var(--text-xl);
      --_pb: 4rem;
    }
    &.size-2xl {
      --_font: var(--text-2xl);
      --_pb: 5rem;
    }
    &.centered {
      margin-inline: auto;
      text-align: center;
      &.width-restricted {
        max-width: 26em;
      }
    }
    &.spacing-none {
      padding-block: 0;
    }
  }
</style>
